<template>
  <b-container class="mb-5" fluid>
    <div class="container-fluid pt-0 px-0">
      <div
        v-if="isMobile || isSmallWindow"
        class="position-relative overflow-hidden"
        style="padding-top: 75%;"
      >
        <iframe
          style="top: 0px; max-width: 100%"
          class="border-0 w-100 top-0 h-100 position-absolute img-margin"
          src="https://player.vimeo.com/video/544483447?color=44619b&amp;title=0&amp;byline=0&amp;portrait=0&amp;badge=0&amp;speed=1"
        ></iframe>
      </div>
    </div>
    <h1>
      {{ $t("login-try-main-title") }}
    </h1>
    <div class="mt-3 pt-2">
      <div class="d-flex d-row mt-3">
        <b-badge
          variant="primary"
          class="rounded-circle list-number mr-3"
          id=""
        >
          1
        </b-badge>
        <div>
          <p>{{ $t("login-try-step-1") }}:</p>
          <b-row>
            <div class="row ml-3">
              <a
                href="https://play.google.com/store/apps/details?id=com.dreszcode.tailie&hl=nl"
                target="_blank"
                ><PlayStore style="height:40px;"/></a
              >&nbsp;&nbsp;
              <a
                href="https://apps.apple.com/nl/app/tailie/id1437534745"
                target="_blank"
                ><AppleAppStore style="height:40px;" />
              </a>
            </div>
          </b-row>
        </div>
      </div>
      <div class="d-flex d-row mt-3">
        <b-badge
          variant="primary"
          class="rounded-circle list-number mr-3"
          id=""
        >
          2
        </b-badge>
        <p>{{ $t("login-try-step-2") }}</p>
      </div>
      <div class="d-flex d-row mt-3">
        <b-badge
          variant="primary"
          class="rounded-circle  list-number mr-3"
          id=""
        >
          3
        </b-badge>
        <p>
          {{ $t("login-try-step-3") }}
        </p>
      </div>
    </div>
  </b-container>
</template>
<script>
import PlayStore from "../../assets/images/google-play.svg";
import AppleAppStore from "../../assets/images/apple-app-store.svg";
export default {
  name: "login-try-now",
  components: {
    PlayStore,
    AppleAppStore
  },
  data() {
    return {
      isSmallWindow: false
    };
  },
  created() {
    this.$gtag.event("try_tailie_now", { method: "Google" });
    window.addEventListener("resize", this.resizeEventHandler);
    this.setSmallPopup();
  },
  destroyed() {
    window.removeEventListener("resize", this.resizeEventHandler);
  },
  methods: {
    resizeEventHandler(e) {
      this.setSmallWindow();
    },
    setSmallWindow() {
      if (window.innerWidth <= 800) {
        this.isSmallWindow = true;
      } else {
        this.isSmallWindow = false;
      }
    }
  },
  computed: {
    isMobile() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        return true;
      } else {
        return false;
      }
    }
  }
};
</script>
<style scoped>
.list-number {
  height: 20px;
  width: 20px;
  min-width: 20px !important;
  line-height: 13px;
  text-align: center;
}
.img-margin {
  margin: 0 auto !important;
}
</style>
